import {cloneDeep as _cloneDeep} from 'lodash';
import AgentModel from "./../../models/AgentModel"
const AgentsModule = {
    namespaced: true,
    state: () => ({
        agents: [],
        agent: _cloneDeep(AgentModel, true),
    }),
    getters: {
        getAgents (state) {
            return state.agents
        },
        getAgent (state) {
            return state.agent
        },
    },
    mutations: {
        setAgents (state, payload) {
            state.agents = payload
        },
        setAgent (state, payload) {
            state.agent = payload
        },
    },
    actions: {
        setAgents (context, payload) {
            context.commit('setAgents', payload);
        },
        setAgent (context, payload) {
            context.commit('setAgent', payload);
        },
    },

}

export default AgentsModule;
